var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: {
        "enter-class": "slide-fade-enter",
        "enter-active-class": "slide-fade-enter-active",
      },
    },
    [
      _c("div", { staticClass: "px-4" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "card-header p-3 col-12" }, [
            _c("h4", { staticClass: "p-0" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("automations.boardLevel.createNewAutomation")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("h6", { staticClass: "text-primary bold text-uppercase" }, [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.$t("automations.boardLevel.selectAppropiateType")
                  ) +
                  "\n        "
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row align-items-center" }, [
          _c(
            "div",
            {
              staticClass:
                "card-body col-lg-6 col-12 py-3 column-divider-right",
            },
            [
              _c("div", { staticClass: "row justify-content-center" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-3 d-flex justify-content-center clickable flex-row align-items-start",
                  },
                  [
                    _c(
                      "plan-tooltip",
                      { attrs: { page: _vm.currentPagePlan } },
                      [
                        _c("img", {
                          staticClass: "img-fluid",
                          class: { disabled: _vm.isUsageRestricted },
                          attrs: {
                            width: "50",
                            src: require("@Broker/@Assets/img/single-person.png"),
                            alt: _vm.$t("global.words.onlyMe"),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.selectShare(false)
                            },
                          },
                        }),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-10 d-flex justify-content-center" },
                  [
                    _c("h6", { staticClass: "bold" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t("automations.boardLevel.triggerableOnlyByMe")
                          ) +
                          "\n            "
                      ),
                    ]),
                  ]
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "card-body col-lg-6 col-12 py-3" }, [
            _c("div", { staticClass: "row justify-content-center" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-3 d-flex justify-content-center clickable flex-row align-items-start",
                },
                [
                  _c("plan-tooltip", { attrs: { page: _vm.currentPagePlan } }, [
                    _c("img", {
                      staticClass: "img-fluid",
                      class: { disabled: _vm.isUsageRestricted },
                      attrs: {
                        width: "100",
                        src: require("@Broker/@Assets/img/team.png"),
                        alt: _vm.$t("global.words.shared"),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.selectShare(true)
                        },
                      },
                    }),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-10 text-center" }, [
                _c("h6", { staticClass: "bold" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.$t(
                          "automations.boardLevel.triggerableByAnyCollaborator"
                        )
                      ) +
                      "\n            "
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }